<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 18V6h20v12h-2v-2h-4v2h-2V8H4v10H2Zm14-8h4V8h-4v2Zm0 4h4v-2h-4v2Z"
    />
  </svg>
</template>
